export const getCurrentTillDestination = ({
	pathname,
	asPath,
	isOfflineMode,
}: {
	pathname: string;
	asPath: string;
	isOfflineMode: boolean;
}) => {
	const tillPath = isOfflineMode ? "/offline/ops/till" : "/ops/till";
	return pathname.startsWith(tillPath) ? asPath : undefined;
};
